import { gql } from "@apollo/client";

export const UnileverContracts = gql`
query UnileverContracts($filter: FilterFindManyUL_mill_contractsInput, $rawFilter: JSON) {
  contracts: bi_ul_mill_contractsMany(filter: $filter, rawFilter: $rawFilter) {
    bonus_as_perc_gmv
    bonus_paid
    buyer_id
    contract_id
    contract_type
    _created_at
    day
    district
    name
    non_ul_quantity
    price_paid
    province
    statement
    subdistrict
    ul_quantity
    _updated_at
    mill_gps_position
  }
}
`

export const UnileverOnboardingV2 = gql`
query Query(
  $dailyPipeline: [JSON]!
  $montlyPipeline: [JSON]!
  $farmerProvinces: [JSON]!
  $count: [JSON]!
) {
  dailyPlotCount: bi_ul_onboarded_land_plotsAggregate(pipeline: $dailyPipeline)
  dailyFarmerCount: bi_ul_onboarded_farmersAggregate(pipeline: $dailyPipeline)
  monthlyPlotCount: bi_ul_onboarded_land_plotsAggregate(pipeline: $montlyPipeline)
  monthlyFarmerCount: bi_ul_onboarded_farmersAggregate(pipeline: $montlyPipeline)
  provinces: bi_ul_onboarded_farmersAggregate(pipeline: $farmerProvinces)
  plotCount: bi_ul_onboarded_land_plotsAggregate(pipeline: $count)
  farmerCount: bi_ul_onboarded_farmersAggregate(pipeline: $count)
}
`

export const UnileverOnboarding = gql`
query Bi_ul_onboarded_farmersMany {
  farmers: bi_ul_onboarded_farmersMany {
    _id
    created_at
    district
    person_id
    province
    subdistrict
    _updated_at
    village
  }

  landplots: bi_ul_onboarded_land_plotsMany {
    _id
    created_at
    district
    land_plot_id
    province
    subdistrict
    _updated_at
    village
  }
}
`